import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { lastValueFrom } from "rxjs";
import { sntLog } from "src/app/common/logger";
import { PRODUCT_TOKEN } from "src/app/core/product.token";
import { ErrorCodes } from "src/app/modules/maintenance/error-codes";
import {
  MemberService,
  MemberWithAccountAndTenant
} from "src/app/services/member.service";
import { maintenance } from "src/app/support/maintenance";
import { SoftwareProduct } from "src/app/support/product";
import { sntNavigate } from "src/app/support/router";

const logger = sntLog("TenantRouterGuard");

@Injectable()
export class TenantRouterGuard {
  readonly #router = inject(Router);
  readonly #memberService = inject(MemberService);

  readonly #product = inject(PRODUCT_TOKEN);

  async canActivate(): Promise<boolean> {
    logger.info("canActivate");

    switch (this.#product) {
      case SoftwareProduct.ADMIN:
      case SoftwareProduct.PLATFORM:
      case SoftwareProduct.DROP_PAGE:
      case SoftwareProduct.BOTMASTER: {
        return true;
      }
      default: {
        const membersWithAccountAndTenant: MemberWithAccountAndTenant[] | null =
          await lastValueFrom(
            this.#memberService.listMembersWithAccountAndTenant()
          );

        switch (true) {
          case !membersWithAccountAndTenant: {
            maintenance(this.#router, { code: ErrorCodes.ERR_013 });
            return false;
          }
          case membersWithAccountAndTenant!.length === 0: {
            maintenance(this.#router, { code: ErrorCodes.ERR_014 });
            return false;
          }
          case membersWithAccountAndTenant!.length === 1: {
            sntNavigate(this.#router, [
              "/",
              membersWithAccountAndTenant[0].account!.domain!.slug,
              membersWithAccountAndTenant[0].account!.slug
            ]);
            return false;
          }
          default: {
            sntNavigate(this.#router, ["/router"]);
            return false;
          }
        }
      }
    }
  }
}
